export var getLineNumWidth = function getLineNumWidth(numLines) {
  return !numLines ? '1ch' : "".concat(numLines.toFixed(0).length, "ch");
};

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * @deprecated
 */
export var getCodeStyles = function getCodeStyles() {
  return {
    display: 'inline',
    padding: '2px 0.5ch',
    backgroundColor: "var(--ds--code--bg-color,".concat("var(--ds-background-neutral, #091E420F)", ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    borderStyle: 'none',
    boxDecorationBreak: 'clone',
    color: "var(--ds-text, #172B4D)",
    fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '0.875em',
    fontWeight: "var(--ds-font-weight-regular, 400)",
    overflow: 'auto',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap'
  };
};